import "../styles/SectionTitle.scss";

function SectionTitle({ children }: any) {
    return <h1 className="section-title">{children}</h1>;
}

export default SectionTitle;
